import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkspaceApiService } from './workspace-api.service';
import { Board } from 'src/app/shared/services/api/boards-api.service';

export interface WorkspaceData {
  name: string;
  description: string;
  avatarLink?: string;
  preInvitedUsers: string[];
  type: string;
}

export interface Workspace {
  id: string;
  name: string;
  subscriptionType: string;
  ownerUuid: string;
  ownerName: string;
  seats: {
    assigned: Array<{
      id: string;
      assigneeUserUuid: string;
      assigneeUserName: string;
      markAsUnassignedNextPeriod: boolean;
      lastAssignedAt: {
        date: string;
        timezone_type: number;
        timezone: string;
      };
    }>;
    unassigned: any[];
  };
  boards?: Board[];
}

export interface WorkspaceResponse {
  my: Workspace[];
  others: Workspace[];
}

@Injectable({
  providedIn: 'root'
})
export class WorkspaceDataService {
  private workspaceData: WorkspaceData = {
    name: '',
    description: 'Description',
    preInvitedUsers: [],
    type: '',
  };

  constructor(private workspaceApiService: WorkspaceApiService) {}

  setSpaceData(name: string, type: string): void {
    this.workspaceData = {
      ...this.workspaceData,
      name,
      type
    };
  }

  setDescription(description: string): void {
    this.workspaceData = {
      ...this.workspaceData,
      description
    };
  }

  setAvatarLink(avatarLink: string): void {
    this.workspaceData = {
      ...this.workspaceData,
      avatarLink
    };
  }

  setPreInvitedUsers(users: string[]): void {
    this.workspaceData = {
      ...this.workspaceData,
      preInvitedUsers: users
    };
  }

  getCurrentData(): WorkspaceData {
    return { ...this.workspaceData };
  }

  createWorkspace(): Observable<any> {
    return this.workspaceApiService.createWorkspaceWithDebug(this.workspaceData);
  }

  getWorkspaces(): Observable<WorkspaceResponse> {
    return this.workspaceApiService.getWorkspaces();
  }
} 